module.exports = __webpack_public_path__ + "img/Cuban_Sandwich_Soy_Gardien.a1149dfe.jpg";